import React from "react";
import IconMenyu from "./IconMenyu";

import Logo from "./Logo";
import "./Menyu.css";
function Menyu({ iconlar, toggleUserPanel, darkMode, toggleDarkMode }) {
  return (
    <div className={`menyu-quti ${darkMode ? "dark" : ""}`}>
      <Logo />
      <IconMenyu toggleUserPanel={toggleUserPanel} darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </div>
  );
}

export default Menyu;
